import { format, isEqual, subDays, formatISO } from 'date-fns';

export const DateTime = (timeStamp: string) => (
  <div className='flex flex-wrap items-center gap-[6px]'>
    <div>{format(new Date(timeStamp), 'dd-LLL-yyyy')}</div>
    <div className='h-[5px] w-[5px] rounded-full bg-spanishGray'></div>
    <div className='text-dimGray'>
      {format(new Date(timeStamp), 'hh:mm:ss')}
    </div>
  </div>
);

export const convertedDateList = (
  from?: Date | string | null | undefined,
  to?: Date | string | null | undefined
) => {
  if (from && to) {
    const fromDate = format(new Date(from), 'yyyy-MM-dd\'T\'HH:mm:ss');
    const toDate = format(new Date(sameDay(to)), 'yyyy-MM-dd\'T\'HH:mm:ss');

    const fromDateUTC = new Date(fromDate).toISOString();
    const toDateUTC = new Date(toDate).toISOString();

    return [fromDateUTC, toDateUTC];
  }

  return [];
};

export const sameDay = (endDate: Date | string) => {
  const currentDate = format(new Date(), 'yyyy-MM-dd');
  const selectedEndDate = format(new Date(endDate as Date), 'yyyy-MM-dd');

  const currentDay = isEqual(new Date(currentDate), new Date(selectedEndDate))
    ? format(new Date(), 'yyyy-MM-dd\'T\'HH:mm:ss')
    : new Date(selectedEndDate + 'T23:59:59');

  return currentDay;
};

// NOTE: the range should be equal or grater that 0.
// If range is negative number - return current date.
// In other cases - return date range array.
export const dateRange = (currentDate: Date, range: number) => {
  if (range < 0) {
    const currentDateFormatted = formatISO(currentDate);

    return [currentDateFormatted, currentDateFormatted];
  }

  const someDaysAgo = subDays(currentDate, range);
  const nowFormatted = formatISO(currentDate);
  const someDaysAgoFormatted = formatISO(someDaysAgo);

  return [someDaysAgoFormatted, nowFormatted];
};

export const convertDateToUTC = (date: Date | null) => {
  if (!date) {
    return null;
  }
  return new Date(date.getTime() + date.getTimezoneOffset() * 60000);
};
